const ScrollContainer = () => ({
  /**
   * Whether the prev button is hidden, i.e. we are on the very left
   */
  prevHidden: true,

  /**
   * Whether the next button is hidden, i.e. we are on the very right
   */
  nextHidden: true,

  /**
   * Current width of the container
   */
  containerWidth: 0,

  /**
   * Event handler for when the container gets resized
   * @returns {void}
   */
  onResize() {
    this.containerWidth = this.$refs.container.getBoundingClientRect().width;
  },

  /**
   * Event handler for when intersection of the first slide changes
   * @param {IntersectionObserverEntry[]} obs Intersection observer entries
   * @returns {void}
   */
  onPrevObs(obs) {
    this.prevHidden = obs[0].isIntersecting;
  },

  /**
   * Event handler for when intersection of the last slide changes
   * @param {IntersectionObserverEntry[]} obs Intersection observer entries
   * @returns {void}
   */
  onNextObs(obs) {
    this.nextHidden = obs[0].isIntersecting;
  },

  /**
   * Apply an offset to the container's current scroll position
   *
   * @param {number} value Scroll offset to apply, in px
   * @returns {void}
   */
  scrollTo(value) {
    const { scrollLeft } = this.$refs.container;

    let left = scrollLeft + value;

    if (left > scrollLeft + this.containerWidth) {
      left = scrollLeft + this.containerWidth;
    } else if (left < 0) {
      left = 0;
    }

    this.$refs.container.scrollTo({ left, behavior: 'smooth' });
  },

  /**
   * Event handler for when the prev button is clicked
   * @returns {void}
   */
  onClickPrev() {
    this.scrollTo(-this.containerWidth);
  },

  /**
   * Event handler for when the next button is clicked
   * @returns {void}
   */
  onClickNext() {
    this.scrollTo(this.containerWidth);
  },

  init() {
    const options = {
      root: this.$refs.container
    };

    const { firstElementChild, lastElementChild } = this.$refs.container;

    const prevObs = new IntersectionObserver(
      this.onPrevObs.bind(this),
      options
    );
    prevObs.observe(firstElementChild);

    const nextObs = new IntersectionObserver(
      this.onNextObs.bind(this),
      options
    );
    nextObs.observe(lastElementChild);
  }
});

export default ScrollContainer;
